import { useEffect as n, useLayoutEffect as t, useState as e, useRef as r, useCallback as u } from "react";
import a from "swr";

function i(n, t, e, r) {
  return new (e || (e = Promise))(function (u, a) {
    function i(n) {
      try {
        c(r.next(n));
      } catch (n) {
        a(n);
      }
    }

    function o(n) {
      try {
        c(r.throw(n));
      } catch (n) {
        a(n);
      }
    }

    function c(n) {
      var t;
      n.done ? u(n.value) : (t = n.value, t instanceof e ? t : new e(function (n) {
        n(t);
      })).then(i, o);
    }

    c((r = r.apply(n, t || [])).next());
  });
}

function o(n, t) {
  var e,
      r,
      u,
      a,
      i = {
    label: 0,
    sent: function sent() {
      if (1 & u[0]) throw u[1];
      return u[1];
    },
    trys: [],
    ops: []
  };
  return a = {
    next: o(0),
    throw: o(1),
    return: o(2)
  }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
    return this;
  }), a;

  function o(a) {
    return function (o) {
      return function (a) {
        if (e) throw new TypeError("Generator is already executing.");

        for (; i;) {
          try {
            if (e = 1, r && (u = 2 & a[0] ? r.return : a[0] ? r.throw || ((u = r.return) && u.call(r), 0) : r.next) && !(u = u.call(r, a[1])).done) return u;

            switch (r = 0, u && (a = [2 & a[0], u.value]), a[0]) {
              case 0:
              case 1:
                u = a;
                break;

              case 4:
                return i.label++, {
                  value: a[1],
                  done: !1
                };

              case 5:
                i.label++, r = a[1], a = [0];
                continue;

              case 7:
                a = i.ops.pop(), i.trys.pop();
                continue;

              default:
                if (!(u = i.trys, (u = u.length > 0 && u[u.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                  i = 0;
                  continue;
                }

                if (3 === a[0] && (!u || a[1] > u[0] && a[1] < u[3])) {
                  i.label = a[1];
                  break;
                }

                if (6 === a[0] && i.label < u[1]) {
                  i.label = u[1], u = a;
                  break;
                }

                if (u && i.label < u[2]) {
                  i.label = u[2], i.ops.push(a);
                  break;
                }

                u[2] && i.ops.pop(), i.trys.pop();
                continue;
            }

            a = t.call(n, i);
          } catch (n) {
            a = [6, n], r = 0;
          } finally {
            e = u = 0;
          }
        }

        if (5 & a[0]) throw a[1];
        return {
          value: a[0] ? a[1] : void 0,
          done: !0
        };
      }([a, o]);
    };
  }
}

var c = "undefined" == typeof window || "Deno" in window,
    l = c ? n : t,
    f = "undefined" != typeof navigator && navigator.connection;
!c && f && (["slow-2g", "2g"].includes(f.effectiveType) || f.saveData);

var s = {}[0],
    v = function v(n) {
  return n === s;
},
    p = function p(n) {
  return "function" == typeof n;
},
    d = new WeakMap(),
    y = 0;

function h(n) {
  if (p(n)) try {
    n = n();
  } catch (t) {
    n = "";
  }
  var t;
  return Array.isArray(n) ? (t = n, n = function (n) {
    if (!n.length) return "";

    for (var t = "arg", e = 0; e < n.length; ++e) {
      var r = n[e],
          u = s;
      null === r || "object" != typeof r && !p(r) ? u = JSON.stringify(r) : d.has(r) ? u = d.get(r) : (u = y, d.set(r, y++)), t += "$" + u;
    }

    return t;
  }(n)) : t = [n = String(n || "")], [n, t, n ? "$err$" + n : "", n ? "$req$" + n : ""];
}

function g(n) {
  return p(n[1]) ? [n[0], n[1], n[2] || {}] : [n[0], null, (null === n[1] ? n[2] : n[1]) || {}];
}

var b = function b(n) {
  return h(n ? n(0, null) : null)[0];
},
    w = function w(n) {
  return "$inf$" + b(n);
},
    $ = function $(n) {
  return function (t, a, c) {
    var f = c.cache,
        d = c.initialSize,
        y = void 0 === d ? 1 : d,
        g = c.revalidateAll,
        w = void 0 !== g && g,
        $ = c.persistSize,
        m = void 0 !== $ && $,
        x = null;

    try {
      x = b(t);
    } catch (n) {}

    var S = e({})[1],
        k = null;
    x && (k = "$ctx$" + x);
    var z = null;
    x && (z = "$len$" + x);
    var A = r(!1),
        D = u(function () {
      var n = f.get(z);
      return v(n) ? y : n;
    }, [z, y]),
        T = r(D());
    l(function () {
      A.current ? x && f.set(z, m ? T.current : y) : A.current = !0;
    }, [x]);
    var V = r(),
        j = n(x ? "$inf$" + x : null, function () {
      return i(void 0, void 0, void 0, function () {
        var n, e, r, u, i, l, s, p, d, y, g, b;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              n = f.get(k) || [], e = n[0], r = n[1], u = [], i = D(), l = null, s = 0, o.label = 1;

            case 1:
              return s < i ? (p = h(t ? t(s, l) : null), d = p[0], y = p[1], d ? (g = f.get(d), b = w || e || v(g) || !s && !v(V.current) || r && !v(r[s]) && !c.compare(r[s], g), a && b ? [4, a.apply(void 0, y)] : [3, 3]) : [3, 5]) : [3, 5];

            case 2:
              g = o.sent(), f.set(d, g), o.label = 3;

            case 3:
              u.push(g), l = g, o.label = 4;

            case 4:
              return ++s, [3, 1];

            case 5:
              return f.delete(k), [2, u];
          }
        });
      });
    }, c);
    l(function () {
      V.current = j.data;
    }, [j.data]);
    var q = u(function (n, t) {
      if (void 0 === t && (t = !0), k) {
        if (t && !v(n)) {
          var e = V.current;
          f.set(k, [!1, e]);
        } else t && f.set(k, [!0]);

        return j.mutate(n, t);
      }
    }, [k]),
        E = u(function (n) {
      var e;
      if (z && (p(n) ? e = n(D()) : "number" == typeof n && (e = n), "number" == typeof e)) return f.set(z, e), T.current = e, S({}), q(function (n) {
        for (var e = [], r = null, u = 0; u < n; ++u) {
          var a = h(t ? t(u, r) : null)[0],
              i = a ? f.get(a) : s;
          if (v(i)) return V.current;
          e.push(i), r = i;
        }

        return e;
      }(e));
    }, [z, D, q]);
    return {
      size: D(),
      setSize: E,
      mutate: q,

      get error() {
        return j.error;
      },

      get data() {
        return j.data;
      },

      get isValidating() {
        return j.isValidating;
      }

    };
  };
},
    m = function (n, t) {
  return function () {
    for (var e = [], r = 0; r < arguments.length; r++) {
      e[r] = arguments[r];
    }

    var u = g(e),
        a = u[0],
        i = u[1],
        o = u[2];
    return o.use = (o.use || []).concat(t), n(a, i, o);
  };
}(a, $);

export { m as default, $ as infinite, w as unstable_serialize };